import { Box, VStack } from "@chakra-ui/react";
import Tooltip from "components/Tooltip";
import FloatingButton from "newui/features/Rfx/components/FloatingButton";
import { KeyboardEvent } from "react";
import { FiEye, FiPlusSquare } from "react-icons/fi";

export const ProcurerQuoteTableQuickActions = ({ addQuoteTableAction, previewAction }) => {

	const onKeyDown = (event: KeyboardEvent<HTMLButtonElement>, option: "add" | "preview") => {
		if (event.key !== "Enter") {
			return;
		}

		event.preventDefault();

		switch (option) {
			case "add":
				addQuoteTableAction?.();
				break;
			case "preview":
				previewAction?.();
				break;
			default:
				break;
		}
	};

	return (
		<FloatingButton
			className="bottom-20"
			position="left"
		>
			<Box
				className="z-40 flex-col rounded-md bg-blue-100 py-2 px-1.5 shadow-md"
				style={{ width: "50px" }}
			>
				<VStack
					gap={2}
					align={"start"}
				>
					<Tooltip
						label="Preview RFx"
						placement="right"
					>
						<button type="button" className="p-2 bg-transparent hover:bg-blue-200 rounded" onClick={previewAction}
							onKeyDown={(event) => onKeyDown(event, "preview")} data-testid="float-preview-rfx">
							<FiEye color="#475467" size={20} />
						</button>
					</Tooltip>
					<Tooltip
						label="Add Quote Table"
						placement="right"
					>
						<button type="button" className="p-2 bg-transparent hover:bg-blue-200 rounded" onClick={addQuoteTableAction}
							onKeyDown={(event) => onKeyDown(event, "add")} data-testid="float-add-question">
							<FiPlusSquare color="#475467" size={20} />
						</button>
					</Tooltip>
				</VStack>
			</Box>
		</FloatingButton>
	);
}